import * as React from "react";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _VerticalSwitchLongLight(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return React.createElement("span", { className: classes, ref: ref, ...rest },
        React.createElement("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("path", { fill: "currentColor", d: "m8 20-.354.354.354.353.354-.353zm6-15.5a.5.5 0 0 0 0-1zM3.646 16.354l4 4 .708-.708-4-4zm4.708 4 4-4-.708-.708-4 4zM8.5 20V8h-1v12zM12 4.5h2v-1h-2zM8.5 8A3.5 3.5 0 0 1 12 4.5v-1A4.5 4.5 0 0 0 7.5 8zM16 8l-.354-.354.354-.353.354.353zm0 8h.5zm-3 3.5a.5.5 0 0 1 0-1zm-1.354-7.854 4-4 .708.708-4 4zm4.708-4 4 4-.708.708-4-4zM16.5 8v8h-1V8zm0 8a3.5 3.5 0 0 1-3.5 3.5v-1a2.5 2.5 0 0 0 2.5-2.5z" })));
}
const VerticalSwitchLongLight = forwardRef(_VerticalSwitchLongLight);
export { VerticalSwitchLongLight };
